import { resolveIsolatedSessionParentPathFromCheckouts } from '../../paths/session-layout-paths.js';
import type { SessionWorktreeBinding } from '../session-worktree-binding.js';
import type { SessionWorktreeCache } from './session-worktree-cache.js';

export function resolveIsolatedSessionParentPath(
  sessionId: string | undefined,
  cache: SessionWorktreeCache,
  ensureRepoCheckoutPaths: (sessionId: string) => string[] | undefined,
): string | null {
  if (!sessionId) return null;
  const sid = sessionId.trim();
  const cached = cache.getSessionParentPath(sid);
  if (cached) return cached;
  const paths = ensureRepoCheckoutPaths(sid);
  if (!paths?.length) return null;
  return resolveIsolatedSessionParentPathFromCheckouts(paths);
}

export function ensureRepoCheckoutPathsForSession(
  sessionId: string | undefined,
  cache: SessionWorktreeCache,
): string[] | undefined {
  if (!sessionId?.trim()) return undefined;
  const cached = cache.getRepoCheckoutPaths(sessionId.trim());
  return cached?.length ? [...cached] : undefined;
}

export async function ensureRepoCheckoutPathsForSessionAsync(
  sessionId: string | undefined,
  cache: SessionWorktreeCache,
  discover: (sessionId: string) => Promise<SessionWorktreeBinding | null>,
): Promise<string[] | undefined> {
  if (!sessionId?.trim()) return undefined;
  const sid = sessionId.trim();
  const cached = cache.getRepoCheckoutPaths(sid);
  if (cached?.length) return cached;
  const disc = await discover(sid);
  if (disc?.repoCheckoutPaths.length) {
    cache.remember(sid, disc);
    return [...disc.repoCheckoutPaths];
  }
  return undefined;
}
